import { render, staticRenderFns } from "./all-deductions.vue?vue&type=template&id=13a78d17"
import script from "./all-deductions.vue?vue&type=script&lang=js"
export * from "./all-deductions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports